//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Card",
  props: {
    element: Object,
    showDetails: Boolean,
    person: Boolean,
    type: String
  },
  methods: {
    details(id) {
      this.$store.dispatch("getTvShowDetails", id);
      this.$router.push({ name: "singleTvshows", params: { id: id } });
    }
  }
};
